import React, { useState, useEffect } from 'react';
import { getMyTransfers, deleteTransfer } from '../services/api';

function MyPosts() {
  const [transfers, setTransfers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadTransfers();
  }, []);

  const loadTransfers = async () => {
    try {
      const res = await getMyTransfers();
      setTransfers(res.data);
    } catch (err) {
      console.error('加载失败', err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('确定要删除这条信息吗？')) return;
    try {
      await deleteTransfer(id);
      loadTransfers();
    } catch (err) {
      console.error('删除失败', err);
    }
  };

  return (
    <div>
      <div className="bg-gradient-to-r from-purple-500 to-purple-700 text-white rounded-xl p-8 mb-8 shadow-xl">
        <h2 className="text-3xl font-bold mb-2">我的发布</h2>
        <p className="text-purple-100">管理您发布的所有对调信息</p>
      </div>

      {loading ? (
        <div className="text-center py-16">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600 mx-auto mb-4"></div>
          <div className="text-gray-500 text-lg">加载中...</div>
        </div>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {transfers.map(t => (
            <div key={t.id} className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 overflow-hidden">
              <div className="bg-gradient-to-r from-purple-50 to-white px-6 py-4 border-b border-gray-100">
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <div className="flex items-center gap-3">
                    <span className={`px-4 py-1.5 rounded-full text-sm font-bold ${t.type === '对调' ? 'bg-green-500 text-white' : 'bg-blue-500 text-white'}`}>
                      {t.type}
                    </span>
                    <span className={`px-4 py-1.5 rounded-full text-sm font-bold ${t.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`}>
                      {t.status === 'active' ? '发布中' : '已下架'}
                    </span>
                  </div>
                  <span className="text-gray-500 text-sm">
                    {new Date(t.created_at).toLocaleDateString()}
                  </span>
                </div>
              </div>
              
              <div className="p-6">
                <div className="grid grid-cols-1 gap-4 mb-4">
                  <div className="bg-blue-50 rounded-lg p-4 border-l-4 border-blue-500">
                    <h3 className="font-bold text-blue-800 mb-2">
                      当前单位
                    </h3>
                    <p className="text-gray-800 font-semibold">{t.current_bureau}局</p>
                    <p className="text-gray-700">{t.current_unit}</p>
                    {t.current_workshop && <p className="text-gray-500 text-sm mt-1"><span className="font-medium">车间:</span> {t.current_workshop}</p>}
                  </div>
                  
                  <div className="bg-red-50 rounded-lg p-4 border-l-4 border-red-500">
                    <h3 className="font-bold text-red-800 mb-2">
                      目标单位
                    </h3>
                    <p className="text-gray-800 font-semibold">{t.target_bureau}局</p>
                    <p className="text-gray-700">{t.target_unit}</p>
                    {t.target_workshop && <p className="text-gray-500 text-sm mt-1"><span className="font-medium">车间:</span> {t.target_workshop}</p>}
                  </div>
                </div>
                
                {t.remark && (
                  <div className="bg-yellow-50 rounded-lg p-4 mb-4 border border-yellow-100">
                    <p className="text-gray-700"><span className="font-semibold text-yellow-800">备注:</span> {t.remark}</p>
                  </div>
                )}
                
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                  <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white px-5 py-3 rounded-lg">
                    <span className="font-semibold">联系方式:</span>
                    <span className="ml-2 font-bold">{t.contact}</span>
                  </div>
                  
                  <button
                    onClick={() => handleDelete(t.id)}
                    className="bg-red-500 hover:bg-red-600 text-white px-6 py-3 rounded-lg font-semibold transition-all duration-300"
                  >
                    删除
                  </button>
                </div>
              </div>
            </div>
          ))}
          
          {transfers.length === 0 && (
            <div className="col-span-full text-center py-20 bg-white rounded-xl shadow-md border border-gray-100">
              <p className="text-gray-500 text-lg font-medium">暂无发布信息</p>
              <p className="text-gray-400 mt-2">去发布第一条对调信息吧！</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default MyPosts;
